{
    "Presence_Page_Title": "Presenza",
    "Presence_SortBy_Title": "Ordina per:",
    "Presence_SortBy_Options_FullName_ASC": "Nome completo (A-Z)",
    "Presence_SortBy_Options_FullName_DSC": "Nome completo (Z-A)",
    "Presence_Search_Title": "Ricerca",
    "Presence_Filter_Title": "Altri filtri",
    "Presence_MoreFilters_Title": "Filtrare per:",
    "Presence_MoreFilters_Options_Department": "Dipartimento",
    "Presence_MoreFilters_Options_Queue": "Coda",
    "Presence_Filter_Availability_All": "Tutti",
    "Presence_Filter_Availability_Available": "Disponibile",
    "Presence_Filter_Availability_Busy": "Occupato",
    "Presence_Filter_Availability_Away": "Via",
    "Presence_Filter_Availability_Offline": "Non in linea",
    "Presence_Filter_Availability_OutOfOffice": "Fuori ufficio",
    "Presence_Filter_Availability_DoNotDisturb": "Non disturbare",
    "Presence_Filter_Availability_BeRightBack": "Torno subito",
    "Presence_Activity_Available_Title": "Disponibile",
    "Presence_Activity_Away_Title": "Via",
    "Presence_Activity_BeRightBack_Title": "Torno subito",
    "Presence_Activity_Busy_Title": "Occupato",
    "Presence_Activity_DoNotDisturb_Title": "Non disturbare",
    "Presence_Activity_InAcall_Title": "In una chiamata",
    "Presence_Activity_InAConferenceCall_Title": "In una teleconferenza",
    "Presence_Activity_Inactive_Title": "Inattivo",
    "Presence_Activity_InAMeeting_Title": "In una riunione",
    "Presence_Activity_Offline_Title": "Non in linea",
    "Presence_Activity_OffWork_Title": "Fuori dal lavoro",
    "Presence_Activity_OutOfOffice_Title": "Fuori ufficio",
    "Presence_Activity_PresenceUnknown_Title": "Presenza sconosciuta",
    "Presence_Activity_Presenting_Title": "Presentare",
    "Presence_Activity_UrgentInterruptionsOnly_Title": "Solo interruzioni urgenti",
    "Presence_NoUsers": "Non ci sono utenti disponibili per il filtro corrente",
    "NAME": "Presence",
    "Presence_Activity_InACall_Title": "In una chiamata",
    "Presence_SearchQuery_TooLong": "La ricerca è troppo lunga"
}